import { type FpPaymentInfo } from '@hooks-api/types/dataModel/fpOrder'
import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { UnorderedList } from '@pets-ui/List/UnorderedList'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { useTranslation } from 'react-i18next'

interface CvsPaymentInfoProps {
  paymentInfo?: FpPaymentInfo | null
}

export function CvsPaymentInfo({ paymentInfo }: CvsPaymentInfoProps) {
  const { t } = useTranslation()
  return (
    <Box borderColor={colors.grey300} borderWidth={1} borderStyle="solid" borderRadius={4}>
      <VStack gap={2} backgroundColor={colors.blueGrey50} borderTopLeftRadius={4} borderTopRightRadius={4} p={3}>
        <HStack justifyContent="space-between">
          <Text variant="body" color={colors.grey600}>{t('orderDetail.convenienceStorePaymentCode', { defaultValue: '超商繳費代碼' })}</Text>
          <Text variant="body" color={colors.grey800} fontWeight="600">
            {paymentInfo?.payment_no || '-'}
          </Text>
        </HStack>
        <HStack justifyContent="space-between">
          <Text variant="body" color={colors.grey600}>{t('orderDetail.paymentDeadline', { defaultValue: '繳費截止日期' })}</Text>
          <Text variant="body" color={colors.red500} fontWeight="600">{paymentInfo?.expire_date}</Text>
        </HStack>
      </VStack>
      <VStack pl={3} pr={2} pt={2}>
        <UnorderedList
          color={colors.grey600}
          fontSize="12px"
          list={[
            t('orderDetail.paymentCvsEnterCodeAndPrint', { defaultValue: '請至超商機台輸入代碼列印繳費單，並前往櫃檯完成繳費' }),
          ]}
        />
      </VStack>
    </Box>
  )
}
